<div class="text-ellipsis" #textEllipsis>
    @if (short) {
        <div class="text texttt" [class.sm]="isSmallText" [innerHTML]="short | safeHtml"></div>
    }
    @if (long) {
        <div class="text" [class.sm]="isSmallText" [innerHTML]="long | safeHtml"></div>
    }
    @if (extra) {
        <div class="text" [class.sm]="isSmallText" [innerHTML]="extra | safeHtml" [hidden]="!isExpanded"></div>
        <div class="text-ellipsis__footer">
            <button (click)="toggleText($event)">
                {{ isExpanded ? 'Collapse' : 'Read more...' }}
            </button>
        </div>
    }
    @if (thingsToDoShort) {
        <p class="text" [class.sm]="isSmallText" [innerHTML]="thingsToDoShort | safeHtml"></p>
        <div class="text-ellipsis__footer">
            <a [routerLink]="getThingsTodoLink(thingsToDoCity)" (click)="toggleText($event)">
                Find out more >
            </a>
        </div>
    }
</div>
